module.exports = __webpack_public_path__ + "img/logo.6c648790.png";